import { types as t } from 'mobx-state-tree';

import { AbstractVocab } from '../../vocab/models/abstract-vocab';
import { QuestionGroup } from '../question-group.store';
import { ImageInfo } from '../Script/abtract-script.store';
import { Test } from '../test.store';
import { AvailableForEnum } from '@doltech/utils/lib/constants';

export const AbstractTestSection = t.model('AbstractTestSection', {
  createdAt: t.maybeNull<any>(t.string),
  duration: t.maybeNull(t.number),
  vocab: t.maybe(AbstractVocab),
  testSectionId: t.maybeNull<any>(t.string),
  id: t.maybeNull<any>(t.string),
  lastModifiedAt: t.maybeNull<any>(t.string),
  name: t.maybeNull<any>(t.string),
  order: t.maybeNull(t.number),
  questionGroups: t.array(QuestionGroup),
  skill: t.maybeNull<any>(t.string),
  status: t.maybeNull<any>(t.string),
  test: t.maybeNull(Test),
  testStatus: t.maybeNull<any>(t.string),
  coverImage: t.maybeNull(ImageInfo),
  publishFor: t.maybeNull<any>(t.optional((t.string), AvailableForEnum.FOR_ALL)),
  topicId: t.maybeNull<any>(t.string),
  studyTemplate: t.maybeNull<any>(t.string),
  passageType: t.maybeNull<any>(t.string),
  sectionType: t.maybeNull<any>(t.string),
});
